import { Component, OnInit, Input, Output, EventEmitter, 
		OnChanges, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';

@Component({
	selector: 'search-facet-picker',
	templateUrl: 'search-facet.component.html'
})

export class SearchFacetComponent implements OnInit, AfterViewInit, OnChanges {
	@ViewChild('inputField') inputField;
	@Input() items: Array<any>;
	@Input() filterListHeight: number;
	@Input() category = 'filter facets here...';
	@Input() reset: boolean;
	@Input() showCount = true;
	@Input() multiple = false;
	@Input() selectedFacet: any[] = [];
	@Input() hideFilters = false;
	@Output() facetItemClick = new EventEmitter();
	@Output() onClear = new EventEmitter();
	fullItems: Array<any>;
	filter: string;
	isSelectAll = true;

	constructor() { }

	ngAfterViewInit() {
		setTimeout(() => this.inputField.nativeElement.focus());
	}

	ngOnInit() {
		this.fullItems = this.items;
		if (!this.filterListHeight) {
			this.filterListHeight = 100;
		}
		if (this.selectedFacet && this.selectedFacet.length) {
			this.selectedFacet = typeof this.selectedFacet[0] === 'string' ? this.selectedFacet : this.selectedFacet.map(x => x.value?? x.title );
		}
		this.items?.forEach(item => {
			const t = item.value?? item.title;
			if (!this.selectedFacet.find(x => x.trim().toLowerCase() === (item.value?? item.title).trim().toLowerCase())) {
				this.isSelectAll = false;
			}
		})
	}

	public valueChange(text: string) {
		if (this.fullItems == null) {
			this.fullItems = this.items;
		}

		if (text === '' || text == null) {
			this.items = this.fullItems;
			return;
		}
		const dataToFilter = this.fullItems;
		this.items = dataToFilter.filter(x => this.checkMatch((x.value?? x.title).toString(), this.filter.toLowerCase()));
	}

	public selectAll() {
		this.isSelectAll = !this.isSelectAll;
		const adds: any[] = [];
		if (this.isSelectAll) {
			this.items.forEach(x => {
				if (this.selectedFacet.indexOf(x.value?? x.title) < 0) {
					this.selectedFacet.push(x.value?? x.title);
					adds.push(x.value?? x.title);
				}
			});
		} else {
			this.items.forEach(x => {
				const index = this.selectedFacet.indexOf(x.value?? x.title);
				if (index >= 0) {
					this.selectedFacet.splice(index, 1);
					adds.push(x.value?? x.title);
				}
			});
		}
		this.facetItemClick.emit({ key: this.isSelectAll, value: adds});
	}

	private checkMatch(value: string, filterText: string) {
		return value.toLowerCase().indexOf(filterText) !== -1;
	}

	public addFacet(event = undefined, isFilter = false) {
		if (!this.multiple || isFilter) {
			this.facetItemClick.emit(this.selectedFacet);
			this.selectedFacet = [];
		} else if (event) {
			const index = this.selectedFacet.indexOf(event);
			if (index >= 0) {
				this.selectedFacet.splice(index, 1);
			} else {
				this.selectedFacet.push(event);
			}
		}
		if (this.hideFilters) {
			this.facetItemClick.emit(event);
		}
	}

	public onReset() {
		this.selectedFacet = [];
		this.onClear.emit();
	}

	ngOnChanges(simpleChange: SimpleChanges) {
		if (this.items) {
			this.items = this.items.filter(x => (x.value?? x.title) !== '')
			// FIX: Clear fullItems to force refresh when items change
			this.fullItems = null;  // Will be re-initialized from items on next search

			// Also clear any existing filter when items change to avoid confusion
			if (simpleChange['items']) {
				this.filter = '';
			}
		}
		if (this.selectedFacet && this.selectedFacet.length) {
			this.selectedFacet = typeof this.selectedFacet[0] === 'string' ? this.selectedFacet : this.selectedFacet.map(x => x.value?? x.title);
		}
		const resetSimpleChange = simpleChange['reset'];
		if (resetSimpleChange && resetSimpleChange.previousValue !== resetSimpleChange.currentValue) {
			this.filter = '';
		}
	}
}
